import { CommonModule } from '@angular/common';
import { Component, Input, NgModule, OnInit } from '@angular/core';
import { Cms } from '@impact/data';

import { SpotBaseDirective } from '../spot-base.class';
import { GridSpotModule } from './grid-spot.module';

@Component({
    selector: 'app-grid-spot',
    template: `
        <div class="layout-wrapper">
            <section class="grid-spot" [ngClass]="{'narrow-spacing': data?.narrowColums , 'no-spacing': data?.noSpacing}">
                <app-grid-spot-item
                    class="grid-spot__item"
                    [class]="columnsModifier"
                    *ngFor="let item of data.items"
                    [columns]="data?.items?.length ?? 1"
                    [image]="item?.imageContent"
                    [textContent]="item.textContent"
                    [backgroundColor]="item.backgroundColor"
                    [imageAsBackground]="item.imageAsBackground"
                    [itemUrl]="item?.itemUrl?.url"
                ></app-grid-spot-item>
            </section>
        </div>
    `,
})
class GridSpotComponent extends SpotBaseDirective implements OnInit {

    @Input() data: Cms.GridSpot;

    columnsModifier: string;

    ngOnInit(): void {

        if (!this.data || !this.data.items || this.data.items.length < 2 || this.data.items.length > 4) {
            return;
        }

        this.columnsModifier = `grid-spot__item--${this.data.items.length}`;
    }
}

@NgModule({
    declarations: [GridSpotComponent],
    imports: [
        CommonModule,
        GridSpotModule
    ]
})
class GridSpotComponentModule {}

export const LazySpotComponent = GridSpotComponent;
